/**
 * PostHog masking markers for session replay and autocapture. `posthog.init`
 * masks form inputs but leaves rendered text alone, so surfaces showing
 * customer content opt in with these classes. Both apply to descendants too.
 */

/** Replaces the element's text with asterisks in replays, keeping layout. */
export const PH_MASK_CLASS = "ph-mask";

/**
 * Blocks the element from replays entirely and drops autocapture events fired
 * on it. For secrets, where the text's shape is already too much.
 */
export const PH_NO_CAPTURE_CLASS = "ph-no-capture";
